// removed by extract-text-webpack-plugin
module.exports = {"container":"_3lO_ma3cZRYLZIRTsRxMU0","infoContainer":"_2VYSGebV9TdpqXaNQfdCR-","diffContainer":"_2QPdszC6lFu5hTAGfUxQIy","diffValue":"qxFpdRnNxQ8nHaImdFFWP","controls":"_3SPguA38JuSIZykHJbiS1L","cancelBtn":"_2Qf1lPGCbP26xFsY-EG-nj","successBtn":"lEdSnC_xTiERszJvAMSs0","label":"_2rZj-kIvs24VAKX8o09q_l","treeContainer":"_38bOwba7DWAPMdHAErhmzV","treeInnerContainer":"_26mVWJ_lMg_tzP6RmVsbgN"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Groups/GroupPage/GrantTree/GrantTree.pcss
// module id = 1414
// module chunks = 0